import React, { useState, useRef, useEffect } from "react";

function RegisterForm({ onRegister, onGoToLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("https://resumefuel.xyz/resume/src/register.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, name }),
      });

      const text = await response.text();
      console.log("Raw response:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (parseErr) {
        console.error("Failed to parse JSON:", parseErr);
        setError("Invalid server response.");
        return;
      }

      if (data.success) {
        onRegister(data.user);
      } else {
        setError(data.message || "Registration failed.");
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Server error. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit} class="form-sec">
      <h2 style={{ marginBottom: 20 }}>Register</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <input
        type="text"
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        style={inputStyle}
        autoComplete="name"
      />
      <input
        ref={emailRef}
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        style={inputStyle}
        autoComplete="email"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        style={inputStyle}
        autoComplete="new-password"
      />
      <button type="submit" style={buttonStyle}>Register</button>

      <p style={{ marginTop: 10 }}>
        Already have an account?{" "}
        <button type="button" onClick={onGoToLogin} style={linkButtonStyle}>
          Login
        </button>
      </p>
    </form>
  );
}

const inputStyle = {
  marginBottom: 15,
  padding: 10,
  borderRadius: 4,
  border: "1px solid #ccc",
  fontSize: 14,
};

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#28a745",
  color: "white",
  border: "none",
  borderRadius: 4,
  fontSize: 16,
  cursor: "pointer",
};

const linkButtonStyle = {
  background: "none",
  border: "none",
  color: "#0070ba",
  cursor: "pointer",
  textDecoration: "underline",
  padding: 0,
  fontSize: "14px",
};

export default RegisterForm;
